module.exports = __webpack_public_path__ + "img/p3.98a333c3.png";